var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isOpen)?_c('div',{staticClass:"modal"},[_c('div',{staticClass:"modal-content"},[_c('button',{staticClass:"close-button",on:{"click":_vm.closeModal}},[_vm._v("×")]),_c('iframe',{attrs:{"src":`https://www.youtube.com/embed/${_vm.videoId}?autoplay=1`,"frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }